export enum LoginPanelType {
	Email = 'email',
	LoginChoice = 'loginChoice',
	Password = 'password',
	RegisterForm = 'registerForm',
}

export default LoginPanelType;
